import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "88342b46-1c81-4c0d-9316-2546bc354773",
    content: "0.7 m/s",
    options: {},
  },
  {
    id: "db8d0230-42ce-4f4a-be9a-4e4e0f068592",
    content: "0.7 km/s",
    options: {},
  },
  {
    id: "f76ddad2-81d1-48ef-8a57-dbea04d207ea",
    content: "3.5 m/s",
    options: {},
  },
  {
    id: "ce3e2add-6ce8-4ce8-9e73-a0e58e315198",
    content: "3.5 km/s",
    options: {},
  },
];

export const task: Task = {
  id: "43001836-9241-4a9f-b570-b0e178ef1ac6",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["f76ddad2-81d1-48ef-8a57-dbea04d207ea"],
};
